export const makeFriendlyAge = (age: number): string => {
  let word = 'лет';
  let count = Math.floor(Math.abs(age)) % 100;

  if (!(count >= 5 && count <= 20)) {
    count = count % 10;

    if (count == 1) {
      word = 'год';
    } else if (count >= 2 && count <= 4) {
      word = 'года';
    }
  }

  return `${age} ${word}`;
};
